import { Toaster } from '@/components/ui/toaster'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { CartProvider } from '@/contexts/CartContext'
import { AuthProvider } from '@/hooks/useAuth'
import CookieConsent from '@/components/CookieConsent'
import ScrollToTop from '@/components/ScrollToTop'

import HotjarScript from '@/components/HotjarScript'
import GoogleAnalyticsScript from '@/components/GoogleAnalyticsScript'
import GoogleAdsScript from '@/components/GoogleAdsScript'
import { useSmoothScroll } from '@/hooks/use-smooth-scroll'
import Index from './pages/Index'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import Login from './pages/Login'
import FAQ from './pages/FAQ'
import Proposito from './pages/Proposito'
import Diferenciais from './pages/Diferenciais'
import Contact from './pages/Contact'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Partnership from './pages/Partnership'
import AdminLogin from './pages/AdminLogin'
import AdminBlog from './pages/AdminBlog'
import NotFound from './pages/NotFound'
import ProductDetails from './pages/ProductDetails'
import OrderPlaced from './pages/OrderPlaced'
import TermsAndConditions from './pages/TermsAndConditions'
import IndexPartners from './pages/partners/Index'
import SobreNos from './pages/partners/SobreNos'
import Cadastro from './pages/partners/Cadastro'
import NotFoundPartners from './pages/partners/NotFound'

const queryClient = new QueryClient()

const AppContent = () => {
  useSmoothScroll()

  return (
    <>
      <Toaster />
      <Sonner />
      <CookieConsent />
      <ScrollToTop />

      <HotjarScript />
      <GoogleAnalyticsScript />
      <GoogleAdsScript />
      <GoogleAdsScript />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/carrinho" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/entrar" element={<Login />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/proposito" element={<Proposito />} />
        <Route path="/diferenciais" element={<Diferenciais />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
        <Route path="/parceria" element={<Partnership />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminBlog />} />
        <Route path="/produtos/:id" element={<ProductDetails />} />
        <Route path="/pedido-realizado" element={<OrderPlaced />} />
        <Route path="/termos-e-condicoes" element={<TermsAndConditions />} />
        <Route path="/parcerias" element={<IndexPartners />} />
        <Route path="/parcerias/sobre" element={<SobreNos />} />
        <Route path="/parcerias/cadastro" element={<Cadastro />} />
        <Route path="/parcerias/*" element={<NotFoundPartners />} />

        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
)

export default App
